module.exports = __webpack_public_path__ + "img/epipen-exp.cf3652c2.png";